import axios from "axios";
import { internals } from "../config/internals";

const baseURL = internals.stixUrl;

const api = axios.create({
  baseURL: `${baseURL}/public/v3`,
});

api.interceptors.request.use((config) => {
  if (config && config.headers) {
    config.headers["ocp-apim-subscription-key"] = internals.apimKey;
    config.headers["Ocp-Apim-Trace"] = true;
  }
  return config;
});

export { api };
